import ActivityActionTypeProvider  from './ActivityActionTypeProvider'

export default ActivityActionTypeProvider
